import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa, BasicApiResponseModel } from '../../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class JobTemplateToProcessTemplateLinkListService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX  + "mrp/mrp-job-template-to-process-template-link/backoffice-ep";
    this.httpClient = http;
  }
  // https://api.akaun.cloud/core2/tnt/dm/mrp/mrp-job-template-to-process-template-link/backoffice-ep/list-options?job_template_guid=994a440e-467d-0472-61a9-2619a0abaa7a&inv_item_hdr_guid=01256367-7bd2-e78d-e695-7b2b4ca55ce1
  
  public getByJobandIvnGuid(
    guidJob: string,
    guidInv: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl + '/list-options?job_template_guid=' + guidJob + '&inv_item_hdr_guid=' + guidInv,
      this.getHttpHeader(visa)
    );
  }
}
